import React from 'react'
import Box from '@material-ui/core/Box'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import useBanner from '../hooks/useBanner'
import useScrollPercent from '../hooks/useScrollPercent'

/**
 * withBannerAccommodator is an HOC that adds some CSS to the header navbar to correctly display
 * it under the banner. It also slides the navbar to stick to the top of the page when the
 * banner slides off after a 50% scroll.
 * @param Component React.ComponentType<P>
 * @returns A react function component
 */
export const withBannerAccommodator = <P extends Record<string, any>>(
  Component: React.ComponentType<P>
): React.FC<P> => {
  const BannerAdapter: React.FC<P> = (props) => {
    const { showBanner } = useBanner()
    const classes = useStyles()
    const navRef = React.useRef<HTMLDivElement>(null)
    useScrollPercent(navRef, 0.5, [classes.slideUp])

    if (showBanner) {
      return (
        <Box
          // Mui doesn't support `ref` for the `<Box />` in v4
          // @ts-ignore
          ref={navRef}
          className={clsx(
            classes.navContainer,
            classes.accomodateBanner,
            classes.animateHeader
          )}
        >
          <Component {...(props as P)} />
        </Box>
      )
    }

    return <Component {...(props as P)} />
  }

  const useStyles = makeStyles((theme) =>
    createStyles({
      navContainer: {
        position: 'sticky',
        zIndex: 1100,
      },
      animateHeader: {
        transition: '0.5s',
      },
      accomodateBanner: {
        top: '3.75rem',

        [theme.breakpoints.down('sm')]: {
          top: '5rem',
        },

        [theme.breakpoints.down('xs')]: {
          top: '7.5rem',
        },
      },
      slideUp: {
        top: 0,
        transition: '0.5s',
      },
    })
  )

  return BannerAdapter
}
